<h2 mat-dialog-title>
  {{ 'common.manage' | t }} <span class="groupName">{{ data?.lprGroup?.name }}</span> {{ 'map.lprComponents.plates' | t }}
</h2>
<form class="search-bar">
  <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
  <sn-icon-button
    icon="search"
    type="submit"
    [matTooltip]="'common.search' | t"
    class="sn-searchbar__search-button"
  >
  </sn-icon-button>
  <sn-icon-button
    icon="close"
    [matTooltip]="'common.clearSearch' | t"
    class="sn-searchbar__clear-button"
    (click)="clear()"
  >
  </sn-icon-button>
</form>
<mat-dialog-content class="mat-typography">
  <div class="fs-row">
    <div class="fs-col">
      <div class="plates-table">
        <sn-data-list #list reloadByQueryParams [fetchFn]="loadData">
          <sn-infinite-scroll>
            <sn-pull-to-refresh>
              <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
              <ng-template
                [ngIf]="!list.dataSource.data.length && list.dataIsInited"
                [ngIfThen]="emptyTmpl"
              ></ng-template>
            </sn-pull-to-refresh>
          </sn-infinite-scroll>
        </sn-data-list>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="success" class="add-plate-button" (click)="addPlate()">
    {{ 'common.addGroup' | t }}
  </button>
  <button mat-button color="danger" mat-dialog-close>{{ 'common.close' | t }}</button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="plate">
      <mat-header-cell *matHeaderCellDef>Plate</mat-header-cell>
      <mat-cell *matCellDef="let plate">
        {{ plate.plate }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-action-list [items]="actions" [context]="item"></sn-action-list>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
    <mat-row matRipple *matRowDef="let camera; columns: columns"> </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t"> {{ 'common.noResultsFound' | t }} </sn-empty-state>
</ng-template>
